import { FC, useState } from 'react'
import { Box, CircularProgress, DialogContent, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import theme from 'theme'
import ThemeButton from 'ui/components/buttons/theme/Button'
import { CustomizedDialog } from '../customize-report-dialog/customizeReportDialog.styles'

interface StopScheduleConfirmationDialogProps {
  isOpen: boolean
  templateName: string
  onClose: () => void
  onConfirm: () => Promise<void>
}

const StopScheduleConfirmationDialog: FC<StopScheduleConfirmationDialogProps> = ({
  isOpen,
  templateName,
  onClose,
  onConfirm
}) => {
  const [isStopping, setIsStopping] = useState(false)

  const handleConfirm = async () => {
    try {
      setIsStopping(true)
      await onConfirm()
    } finally {
      setIsStopping(false)
    }
  }

  return (
    <CustomizedDialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="stop-schedule-dialog"
      maxWidth={false}
      sx={{
        '.MuiDialog-paper': {
          width: '664px !important',
          padding: '32px !important',
          minHeight: 'auto'
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%', mb: '24px' }}>
        <Typography
          sx={{
            color: theme.colors.menuItemText,
            textAlign: 'center',
            fontFamily: theme.typography.fontFamily.primary,
            fontSize: '28px',
            fontWeight: theme.typography.fontWeight.bold,
            lineHeight: '42px',
            flex: '1 0 0'
          }}
        >
          Stop Report Schedule for &lsquo;{templateName}&rsquo;
        </Typography>
        <IconButton onClick={onClose} sx={{ color: theme.colors.devicesSecondaryText }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 0, width: '100%' }}>
        <Typography
          sx={{
            fontSize: theme.typography.fontSize.large,
            color: theme.colors.devicesSecondaryText,
            textAlign: 'center'
          }}
        >
          This will stop the automatic generation of this report. You can still download it manually or restart the
          schedule at any time.
        </Typography>
      </DialogContent>
      <Box sx={{ display: 'flex', gap: 1, width: '100%', mt: '48px' }}>
        <ThemeButton themevariant="secondary" onClick={onClose} disabled={isStopping} sx={{ flex: 1, height: '48px' }}>
          Cancel
        </ThemeButton>
        <ThemeButton themevariant="primary" onClick={handleConfirm} disabled={isStopping} sx={{ flex: 1, height: '48px' }}>
          {isStopping ? <CircularProgress size={18} color="primary" /> : 'Stop Schedule'}
        </ThemeButton>
      </Box>
    </CustomizedDialog>
  )
}

export default StopScheduleConfirmationDialog
